module.exports = __webpack_public_path__ + "static/img/new_header_bg.799c63f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/header/new_header_bg.png
// module id = CoUd
// module chunks = 1